import { AdditionalTile } from "../track/track-response";

export interface MyMachinesResponse {
    title: string;
    link: string;
    linkTitle: string;
    isCreateCaseAllowed: boolean;
    disabledCreateCaseHeaderText?: string;
    disabledCreateCaseBodyText?: string;
    items?: Machine[];
    noData?: boolean;
    noDataText?: string;
    noMachinesText?: string;
    noMachinesButton?: string;
    additionalTile?: AdditionalTile;
    messages?: {
        chooseShop: string;
        serviceCallLinkText?: string;
        detailLinkText: string;
    };
    authImages?: boolean;
}

export interface Machine {
    name: string;
    number: string;
    detailLink: string;
    shopLinks: ShopLink[];
    serviceCallLink: string;
    serviceCallModalLink: string;
    image: string;
}

export interface ShopLink {
    link: string;
    shopType: ShopType;
    linkText: string;
    linkTarget: string;
}

export enum ShopType {
    BENDING = "bending",
    PUNCHING = "punching",
    SPAREPARTS = "spareparts"
}
